<!-- Статистика -->
<template>
  <li
    v-if="canSeePage('analytics')"
    class="nav-item"
    role="button"
    tabindex="0"
    @click="navigate($event, 'Analytics')"
    @mouseup="handleMiddleClick($event, 'Analytics')"
    @contextmenu.prevent.stop="showContextMenu($event, 'Analytics')"
    :class="{ active: activeItem === 'analytics' }"
    :title="collapsed ? 'Статистика' : ''"
  >
    <div class="link-icon_box">
      <svg
        width="24px"
        height="24px"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        class="icon"
      >
        <rect x="3" y="12" width="4" height="9" rx="1" />
        <rect x="10" y="7" width="4" height="14" rx="1" />
        <rect x="17" y="3" width="4" height="18" rx="1" />
      </svg>
    </div>
    <span v-if="!collapsed" class="nav-link">Статистика</span>
  </li>
</template>

<script>
import {
  useSidebarItem,
  sidebarItemProps,
} from "@/composables/useSidebarItem";

export default {
  name: "AnalyticsItem",
  props: sidebarItemProps,
  emits: ["navigate", "middle-click", "context-menu"],
  setup(props, { emit }) {
    return useSidebarItem(emit);
  },
};
</script>
